import api from '@/rest-api'

export default {
    register(data, cardCreation=false) {
        return api.post(`/member/register?cardCreation=${cardCreation}`, data)
    }
}